<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_icon_p">
      <img :src="app_root + '/assets/common/img/install_meishi.png'">
    </div>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_badge">
      <p class="app_title">
        <LabelFunMessage fcontId="0" msgkey="28" />
      </p>

      <a 
        v-on:click="trackGa4AppDownloadEvent()"
        href="https://itunes.apple.com/jp/app/epson-%E5%90%8D%E5%88%BA%E3%83%97%E3%83%AA%E3%83%B3%E3%83%88/id1067182691?mt=8"
        target="itunes_store"><img
        :src="app_root + '/assets/common/img/button/Download_on_the_App_Store_Badge_US-UK_135x40.svg'" class="app_store"></a>
      <a 
        v-on:click="trackGa4AppDownloadEvent()"
        href="https://play.google.com/store/apps/details?id=com.epson.cardprint" target="_blank"><img
        :src="app_root + '/assets/common/img/button/google-play-badge.png'" class="google_play"></a>

      <p class="dl_site"><span class="glyphicon glyphicon-info-sign"></span>
        <LabelFunMessage fcontId="0" msgkey="12" />
      </p>
      <p><a href="https://support.epson.net/appinfo/cardprint/list/ios/ja/index.html" target="_blank"
          rel="noopener">
          <LabelFunMessage fcontId="150" msgkey="52" />&nbsp;&raquo;
        </a>
        </p>
      <p><a href="https://support.epson.net/appinfo/cardprint/list/android/ja/index.html" target="_blank"
        rel="noopener">
        <LabelFunMessage fcontId="150" msgkey="53" />&nbsp;&raquo;
      </a>
      </p>
    </div>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "AppDownloadCardPrint",
  components: {
    LabelFunMessage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1)
    }
  },
  methods: {
    trackGa4AppDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "Card Print",
        "location_id": "article",
        "article_no": this.fcontId,
        "site_id": "gallery"
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>